import '../css/select2/core.scss';
import '../css/casafari-crm-wp-public.scss';
import $ from 'jquery';
import 'select2';                       // globally assign select2 fn to $ element

console.log('loaded: casafari-crm-wp-public.js');

window.onload = function(){

    initFakeSelect();
    initPropertyVideos();

    function initFakeSelect(){
        const fakeSelectButtons = document.querySelectorAll('.menu-btn-fs');
        const fakeSelectDropDownMenus = document.querySelectorAll('.menu-fs');
        const fakeSelectDropDownMenusCheckbox = document.querySelectorAll('.menu-fs input[type="checkbox"]');

        // add click event to fake select buttons
        fakeSelectButtons.forEach(item => {
            item.addEventListener("click", toggleFakeSelectDropDownEvent);
        })

        // add click event do checkbox, to find the closest li, and add a class checked to it, to give it the same style as hover
        fakeSelectDropDownMenusCheckbox.forEach(item => {
            item.addEventListener("click", (event) => {
                event.target.closest("li").classList.toggle("checked");
            });
        })

        // listen for every click in the DOM, to figure out if user clicks outside the fake select opened menu
        document.addEventListener("click", (event) => {
            // if it isn't a button .menu-btn-fs
            if( !event.target.classList.contains("menu-btn-fs") ) {
                fakeSelectDropDownMenus.forEach(item => {
                    if( !item.contains(event.target) ) {
                        let btn = item.parentElement.querySelector(".menu-btn-fs");
                        hideFakeSelectDropdown(item, btn);
                        //console.log("Clicked outside, hide!");
                    }
                });
            }
        });

        function toggleFakeSelectDropDownEvent(event) {
            const fsDropDownMenuButtonEl = event.target;
            const fsDropDownMenuEl = event.target.parentElement.querySelector(".menu-fs");

            toggleFakeSelectDropdown(fsDropDownMenuEl, fsDropDownMenuButtonEl);

            fakeSelectDropDownMenus.forEach(item => {
                let btn = item.parentElement.querySelector(".menu-btn-fs");

                if( btn != fsDropDownMenuButtonEl ) {
                    hideFakeSelectDropdown(item, btn);
                }
            });
        }

        function toggleFakeSelectDropdown(fsDropDownMenuEl, fsDropDownBtnEl) {
            fsDropDownMenuEl.classList.toggle("d-none");
            //fsDropDownMenuEl.classList.toggle("opened");
            //fsDropDownBtnEl.classList.toggle("active");
        }

        function hideFakeSelectDropdown(fsDropDownMenuEl, fsDropDownBtnEl) {
            fsDropDownMenuEl.classList.add("d-none");
            //fsDropDownMenuEl.classList.remove("opened");
            //fsDropDownBtnEl.classList.remove("active");
        }
    }

    function initPropertyVideos() {

        // get youtube video id from Url
        const getYouTubeVideoIdFromUrl = ( url ) => {
            // Our regex pattern to look for a youTube ID
            const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
            //Match the url with the regex
            const match = url.match(regExp);
            //Return the result
            return match && match[2].length === 11 ? match[2] : undefined;
        };

        // get youtube video id from Url
        const getVimeoIdFromUrl = ( url ) => {
            // Look for a string with 'vimeo', then whatever, then a
            // forward slash and a group of digits.
            const match = /vimeo.*\/(\d+)/i.exec(url);
            // If the match isn't null (i.e. it matched)
            if (match) {
                // The grouped/matched digits from the regex
                return match[1];
            }
        };

        const generateYouTubeUrl = ( videoId ) => {
            return `//www.youtube.com/embed/${videoId}?autoplay=1&autohide=1&showinfo=0&modestbranding=1&controls=0&mute=0&rel=0&enablejsapi=1`;
        };

        const generateVimeoUrl = ( videoId ) => {
            return `https://player.vimeo.com/video/${videoId}?&autoplay=1&loop=1&title=0&byline=0&portrait=0&muted=1&#t=235s`;
        };

        document.querySelectorAll(':is(vimeo-embed, youtube-embed) button').forEach(button => button.addEventListener('click', () => {
            const parent_el = button.parentElement;
            const video = button.previousElementSibling;
            let video_url = null;

            console.log( parent_el.tagName );

            if( parent_el.tagName.toUpperCase() == 'VIMEO-EMBED' ) {
                const vimeo_video_id = getVimeoIdFromUrl( video.dataset.src );
                if( vimeo_video_id != undefined ) {
                    video_url = generateVimeoUrl( vimeo_video_id );
                }
            } else if ( parent_el.tagName.toUpperCase() == 'YOUTUBE-EMBED' ) {
                const youtube_video_id = getYouTubeVideoIdFromUrl( video.dataset.src );
                console.log( youtube_video_id );
                if( youtube_video_id != undefined ) {
                    video_url = generateYouTubeUrl( youtube_video_id );
                }
            }

            if( video_url != null ) {
                video.src = video_url;
            }
        }))

    }
}


$( function() {
    'use strict';

    $('#property-form select, #orderby').select2();

    initPropertiesPage();
    initGridLayoutAction();
	initRowLayoutAction();
	initMapLayoutAction();

    /**
	 * All of the code for your public-facing JavaScript source
	 * should reside in this file.
	 *
	 * Note: It has been assumed you will write jQuery code here, so the
	 * $ function reference has been prepared for usage within the scope
	 * of this function.
	 *
	 * This enables you to define handlers, for when the DOM is ready:
	 *
	 * $(function() {
	 *
	 * });
	 *
	 * When the window is loaded:
	 *
	 * $( window ).load(function() {
	 *
	 * });
	 *
	 * ...and/or other possibilities.
	 *
	 * Ideally, it is not considered best practise to attach more than a
	 * single DOM-ready or window-load handler for a particular page.
	 * Although scripts in the WordPress core, Plugins and Themes may be
	 * practising this, we should strive to set a better example in our own work.
	 */

     function initPropertiesPage (){
        var $form = $('#property-form');
        if (!$form.length) {
            return;
        };
        $form.on('submit',function(e){
            if (!$(this).hasClass('flex-form-section')) {
                e.preventDefault();
                var data = $form.serialize();
                var orderby = $('#orderby').val();
                if (orderby) {
                    data = data + '&order_by=' + orderby;
                };
                var url = $form.attr('action') + '?' + data;
                $('.main-search').addClass('processing');

                /* console.log( url ); */

                $.ajax({
                    type: "GET",
                    url: url,
                    success: function (res) {

                        var posts = $(res).find('.properties-grid').html();
                        $('.properties-grid').html(posts);
                        lazyLoad();

                        var count = $(res).find('.results-counter .counter').html();
                        $('.results-counter .counter').html(count);

                        initMaps();
                        if ($('.properties-grid').hasClass('map-layout')) {
                            $('.map-layout-btn').get(0).click();
                        }

                        window.history.replaceState('', '', url);
                        $('.main-search').removeClass('processing');

                    },
                    error: function (jqXHR, exception) {
                        console.log(jqXHR);
                    }
                });
            }
        });

        $(document).on('click','.properties-grid .posts-nav a',function(e){
            e.preventDefault();
            var url = $(this).attr('href');
            $('.posts-nav').addClass('processing');
            $.ajax({
                type: "GET",
                url: url,
                success: function (res) {

                    var posts = $(res).find('.properties-grid').html();
                    $('.properties-grid').html(posts);
                    lazyLoad();

                    var count = $(res).find('.results-counter .counter').html();
                    $('.results-counter .counter').html(count);

                    initMaps();
                    if ($('.properties-grid').hasClass('map-layout')) {
                        $('.map-layout-btn').get(0).click();
                    }

                    window.history.replaceState('', '', url);

                    $([document.documentElement, document.body]).animate({
                        scrollTop: $(".main-search").offset().top
                    }, 300);

                    $('.posts-nav').removeClass('processing');

                },
                error: function (jqXHR, exception) {
                    console.log(jqXHR);
                }
            });
        });

        $('#orderby').on('change',function(){
            $form.trigger('submit');
        });
    }

    function initGridLayoutAction() {
        let gridBtn = document.querySelector('.grid-layout-btn');
        let grid = document.querySelector('.properties-grid');
        if (!gridBtn && !grid) {
            return;
        }

        gridBtn.addEventListener('click', e => {
            e.preventDefault();
            if (grid.classList.contains('map-layout')) {
                grid.classList.remove('map-layout');
            }

            let rowLayout = document.querySelector('.row-layout');
            if (rowLayout) {
                rowLayout.classList.remove('row-layout');
            }
        });
    }

    function initRowLayoutAction() {
        let rowBtn = document.querySelector('.row-layout-btn');
        let grid = document.querySelector('.properties-grid');
        if (!rowBtn && !grid) {
            return;
        }

        rowBtn.addEventListener('click', e => {
            e.preventDefault();
            if (grid.classList.contains('map-layout')) {
                grid.classList.remove('map-layout');
            }
            grid.classList.add('row-layout');
        });
    }

    function initMapLayoutAction() {
        let mapBtn = document.querySelector('.map-layout-btn');
        let grid = document.querySelector('.properties-grid');
        if (!mapBtn && !grid) {
            return;
        }

        mapBtn.addEventListener('click', e => {
            e.preventDefault();
            grid.classList.add('map-layout');

            // OLD GMAPS
            /* if (window.oo_map && window.oo_bounds) {
                window.oo_map.fitBounds(window.oo_bounds);
            }; */

            // resize and recenter map on btn click
            if ( window.oo_map && window.oo_mapBounds ) {
                window.oo_map.fitBounds( window.oo_mapBounds );
            }
        });
    }

    function lazyLoad() {
        if ('loading' in HTMLImageElement.prototype) {
            let images = document.querySelectorAll('img.lazyload');
            images.forEach(function(img) {
                img.onload = function() {
                    img.classList.add('lazyloaded');
                    if (img.classList.contains('svg-html')) {
                        replaseInlineSvg(img);
                    }
                }
                img.src = img.dataset.src;
            });
        } else {
            if (!loadLazyLoadScript) {
                loadLazyLoadScript = true;
                let script = document.createElement('script');
                script.async = true;
                script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.3.0/lazysizes.min.js';
                document.body.appendChild(script);
            }

            document.addEventListener('lazyloaded', function(e) {
                let img = e.target;
                if (img.classList.contains('svg-html')) {
                    replaseInlineSvg(img);
                }
            });
        }
    }

} );
